import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URLS from "../../urls";
//axios
import axios from "../../utils/axios";

//---------------------------------------------------------------

// GET =>  get Receiving Notes FRom Parent
export const getReceivingNotes = createAsyncThunk(
    "notes/getReceivingNotes",
    async (prams, thunkAPI) => {
        try {
            const response = await axios.get(URLS.getParentNotesURL, {
                params: {
                    school_id: prams?.school_id,
                },
            });
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);


// GET =>  get Sending Notes From School
export const getSendingNoteFromSchool = createAsyncThunk(
    "notes/getSendingNoteFromSchool",
    async (prams, thunkAPI) => {
        try {
            const response = await axios.get(
                URLS.getSendingNoteFromSchoolURL,
                {
                    params: {
                        school_id: prams?.school_id,
                        page: prams?.page
                    },
                }
            );
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);